import queryString from "query-string";

export const stringifySearchParams = (queryParams) => {
  return queryString.stringify(queryParams, {
    arrayFormat: "comma",
    skipEmptyString: true,
    skipNull: true,
  });
};
